module.exports = __webpack_public_path__ + "static/agent-banking-new-banner-a94e9eb8979f41687c842ce593711899.png";